import { createFileRoute } from '@tanstack/react-router';
import { strategiesAtom } from 'r/atoms';
import { useAtomValue } from 'jotai';

export const Route = createFileRoute('/(admin)/xxx')({
  component: RouteComponent,
});

function RouteComponent() {
  const strategies = useAtomValue(strategiesAtom);
  return (
    <div className="flex flex-col items-center justify-center pt-10">
      <div>
        {strategies
          .filter((x) => x.source !== 'mcp')
          .toSorted((a) => (a.source === 'sanr_api' ? 1 : -1))
          .map(({ issuerId, portfolioID, source }, idx) => (
            <a
              className="block text-h-5 text-center h-12 hover:text-blue-400"
              key={idx}
              href={`/${issuerId}/${portfolioID}?source=${source}`}
            >
              {portfolioID}
              {source === 'sanr_api' ? ' (sanr_api)' : ''}
            </a>
          ))}
      </div>
    </div>
  );
}
